import PropTypes from 'prop-types';

import './RelevantLink.scss';

const RelevantLink = ({ href, title, imgSrc }) => (
  <a className="relevant-link" href={href} target="_blank" rel="noreferrer">
    <span>{title}</span>
    <img src={imgSrc} alt={title} />
  </a>
);

RelevantLink.propTypes = {
  href: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  imgSrc: PropTypes.string.isRequired
};

export default RelevantLink;
